

import Vue from 'vue'
import FastClick from 'fastclick'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import WechatPlugin from 'vux/src/plugins/wechat/index.js'

import store from './store'
import sess from './libs/sess'
import VueRouter from 'vue-router'
import '@/plugins/mobile.js'
import routes from './route'
import http from './libs/http'
import App from './App'
import browser from '@/plugins/browser'
import cookie from 'vux/src/tools/cookie/index.js'


import VueAwesomeSwiper from 'vue-awesome-swiper'


import 'swiper/dist/css/swiper.css'

import Es6Promise from 'es6-promise'
Es6Promise.polyfill()

Vue.use(VueAwesomeSwiper, /* { default global options } */)
Vue.use(VueRouter)
Vue.use(AlertPlugin)
Vue.use(ToastPlugin)
Vue.use(LoadingPlugin)
Vue.use(ConfirmPlugin)
Vue.use(WechatPlugin)
Vue.prototype.$sess = sess
Vue.prototype.$cookie = cookie
Vue.prototype.$http = http
Vue.prototype.$browser = browser()

const router = new VueRouter({
mode: 'history',
routes
})
FastClick.attach(document.body)

Vue.config.productionTip = false

router.beforeEach(function (to, from, next) {
window.document.title = to.name;
next()
})
router.afterEach((toRoute, fromRoute) => {
window.scroll(0,0)
if (window.gtag) {
let pageVal = toRoute.fullPath
gtag('event', 'set', { 'page': 'page', 'pageVal': pageVal });
gtag('event', 'send', { 'pageview': 'pageview' });
}

store.commit('updateLoadingStatus', {isLoading: false})
})
/* eslint-disable no-new */
new Vue({
store,
router,
render: h => h(App)
}).$mount('#app-box')



// WEBPACK FOOTER //
// ./src/main.js